// src/pages/MedicalArticles.jsx
import "bootstrap/dist/css/bootstrap.min.css";
import { FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "../../layouts/header";
import Footer from "../../layouts/footer";
import { FaFileLines } from "react-icons/fa6";

const MedicalArticles = () => {
    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        axios.get("https://secopp-admin-3l7e.onrender.com/api/blog")
            .then((res) => {
                setBlogs(res.data);
            })
            .catch((err) => {
                console.error("Error fetching blogs:", err);
            });
    }, []);

    const cancerBlogs = blogs
        .filter(blog => blog.blogCategory.toLowerCase() === "cancer" || blog.blogCategory.toLowerCase() === "oncology")
        .slice(0, 6);

    const orthoBlogs = blogs
        .filter(blog => blog.blogCategory.toLowerCase() === "orthopedic")
        .slice(0, 6);

    const renderBlogCards = (blogsToRender) => (
        <div className="row">
            {blogsToRender.map((blog) => (
                <div key={blog._id} className="col-md-4 mb-4" data-category={blog.blogCategory}>
                    <Link to={`/blog-details/${blog._id}`} className="text-decoration-none text-dark">
                        <div className="card h-100">
                            <div className="row g-0">
                                <div className="col-md-4">
                                    <img
                                        src={blog.blogCardImage}
                                        className="img-fluid rounded-start"
                                        alt="Blog Thumbnail"
                                    />
                                </div>
                                <div className="col-md-8">
                                    <div className="card-body">
                                        <p className="card-text fw-bold text-truncate">
                                            {blog.blogCardTitle}
                                        </p>
                                        <small className="text-body-secondary">
                                            <FaFileLines className="mr-2" /> {blog.blogCategory} | {blog.blogCardDescription}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
            ))}
        </div>
    );

    return (
        <>
            <Header />
            <div className="container my-5">
                {/* Section 1: Cancer */}
                <section className="mb-5">
                    <h2 className="h4 font-weight-bold mb-4">Latest From Cancer (Oncology)</h2>
                    {renderBlogCards(cancerBlogs)}
                    <div className="d-flex justify-content-start mt-4">
                        <Link to="/blog-category/cancer" className="btn btn-primary" style={{ backgroundColor: "#00213e" }}>
                            Know More <FaArrowRight className="ml-2" />
                        </Link>
                    </div>
                </section>

                {/* Section 2: Orthopedic */}
                <section className="mb-5">
                    <h2 className="h4 font-weight-bold mb-4">Latest From Orthopedic</h2>
                    {renderBlogCards(orthoBlogs)}
                    <div className="d-flex justify-content-start mt-4">
                        <Link to="/blog-category/orthopedic" className="btn btn-primary" style={{ backgroundColor: "#00213e" }}>
                            Know More <FaArrowRight className="ml-2" />
                        </Link>
                    </div>
                </section>
            </div>
            <Footer />
        </>
    );
};

export default MedicalArticles;
